'use client';

import { cn } from '#/lib/utils';
import { Translation } from 'intl-lib';
import { ChevronRight } from 'lucide-react';
import { ReactComponent as FlashIcon } from './images/flash.svg';

export default function Page() {
  return (
    <details
      className={cn(
        'group rounded-2xl flex flex-col w-full',
        'bg-linear-to-r from-[#E9F0FF] via-[#FFFFFF] to-[#F9F5FF]'
      )}
    >
      <summary className="cursor-pointer flex items-center justify-between p-5 select-none">
        <div className="flex items-center gap-3">
          <FlashIcon className="size-5" />
          <span className="text-base font-bold">
            <Translation path="my_staking.upgrade_guide.title" />
          </span>
        </div>
        <ChevronRight className="w-5 h-5 transition group-open:rotate-90" />
      </summary>
      <article className="p-5 pt-0 prose max-w-none">
        <Translation path="my_staking.upgrade_guide.description" />
      </article>
    </details>
  );
}
